import { create } from 'zustand';

/** Chrome state of the shell: which controller tool is open. */
interface ShellState {
  /** Controller tool whose pane is open (only one at a time). */
  openTool: string | null;
  /** A pane has been open this session: the bottom row stays docked to the pane's bottom line. */
  panelSeen: boolean;
  toggleTool: (id: string) => void;
  closeTool: () => void;
}

export const useShell = create<ShellState>()((set, get) => ({
  openTool: null,
  panelSeen: false,
  toggleTool(id) {
    const next = get().openTool === id ? null : id;
    set(next ? { openTool: next, panelSeen: true } : { openTool: null });
  },
  closeTool: () => set({ openTool: null }),
}));
